import { Box, Heading, Text, Button } from "@chakra-ui/react";
import { Link } from "react-router";

const NotFound = () => (
  <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    height="100vh"
    textAlign="center"
  >
    <Heading mb={4}>404</Heading>
    <Text mb={4}>Oops! Page not found.</Text>
    <Button asChild>
      <Link to="/">Back Home</Link>
    </Button>
  </Box>
);

export default NotFound;
